import React, { Fragment, useState } from "react";
import { isMobile } from "react-device-detect";
import { Dialog } from "@material-ui/core";
import OpTaskForm from "./OpTaskForm";
import { DownloadStSampleFile } from "../apiServices";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo } from "../../../../utils";
import CamoCTA from "../../../../shared_elements/components/cta/CamoCTA";

const OpSearchBar = ({ applyingFilter, tabIndex, pageLoader, props, searchData, fileUploadData, importFile, exportReportFn, currentRecordPerPage, uuid, getResponseBack, engineType, basicDetails, assetsDetail }) => {
	const [open, setOpen] = useState(false);
	const [formTitle, setFormTitle] = useState("");
	const [actionType, setActionType] = useState("");

	const addNewTask = () => {
		setOpen(true);
		setFormTitle("Op History");
		setActionType("add");
	};

	const importFileFunc = (e) => {
		const files = e.target.files;
		const formData = new FormData();
		formData.append("file", files[0]);
		importFile(formData, props, true);
		e.target.value = null;
	};

	const filterParams = convertFilterObject(removeEmptyKey(applyingFilter));

	return (
		<Fragment>
			<div id="AmpSearchBar">
				<CamoCTA
					searchPlaceholder="Search By Operator, A/C, Event, Shop"
					onSearch={(value) => searchData({ target: { value } })}
					permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
					addLabel="ADD OP HISTORY"
					onAddFn={addNewTask}
					onImportFn={importFileFunc}
					exportMenu={{
						exportReportFn: exportReportFn,
						files: [
							{ title: 'PDF', extension: 'pdf', key: '' },
							{ title: 'EXCEL', extension: 'xlsx', key: '' },
						],
					}}
					downloadSampleMenu={{
						exportReportFn: (file) => DownloadStSampleFile(
							{ download: file.extension, ...filterParams, asset_type: tabIndex },
							pageLoader, props, basicDetails
						),
						files: [
							{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', key: '' },
						],
					}}
				/>
				<Dialog open={open} style={{ height: isMobile && "650px" }}>
					<OpTaskForm
						formTitle={formTitle}
						closeAddForm={() => setOpen(false)}
						addForm={() => setOpen(true)}
						props={props}
						actionType={actionType}
						fileUploadData={fileUploadData}
						currentRecordPerPage={currentRecordPerPage}
						uuid={uuid}
						getResponseBack={() => getResponseBack()}
						engineType={engineType}
						basicDetails={basicDetails}
						assetsDetail={assetsDetail}
					/>
				</Dialog>
			</div>
		</Fragment>
	);
};

export default OpSearchBar;
